module.exports = __webpack_public_path__ + "static/img/2-06.419f9d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-06.png
// module id = 223
// module chunks = 0